<template>
  <section class="MainCanvas">
    <div class="MainCanvas-wrapper" ref="wrapper">
      <div class="MainCanvas-bg"></div>
      <div class="MainCanvas-rect MainCanvas-rect--loader">
        <svg xmlns="http://www.w3.org/2000/svg" ref="svg">
          <rect x="0" width="100%" height="100%" rx="5" />
        </svg>
      </div>
      <div class="MainCanvas-rect">
        <svg xmlns="http://www.w3.org/2000/svg" ref="svg2">
          <rect x="0" width="100%" height="100%" rx="5" />
        </svg>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Canvas from '@/components/Canvas'
import gsap from 'gsap'
// import EventBus from '@/utils/event-bus'

export default {
  data () {
    return {
      scene: null,
      unsubscribe: null,
      loading: true,
      bgOk: false,
      stcOk: false,
      tl: null
    }
  },
  watch: {
    isLoading: function (newVal, oldVal) {
      // if (this.scene) this.scene.init()
      if (newVal === false) {
        this.scene.init(this.collage)
      }
    },
    'collage.sentence': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.scene && this.scene.initiated) this.scene.onCollageChange(newVal)
        // else console.warn('scene is not ready')
      }
      // console.log(onAssetChange)
    },
    'collage.bg': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.scene && this.scene.initiated) this.scene.onBgChange(newVal)
        // else console.warn('scene is not ready')
      }
    }
  },
  computed: {
    ...mapState({
      // backgrounds: 'backgrounds',
      // collages: 'sentences',
      collage: 'collage',
      isLoading: 'loading'
    })
  },
  mounted () {
    this.createScene()
    if (!this.isLoading) this.scene.init(this.collage)

    // EventBus.$on('startApp', this.checkIfReady)

    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (!this.scene) return
      if (mutation.type === 'SET_SENTENCE') {
        // this.scene.onCollageChange(state.collage.sentence)
      } else if (mutation.type === 'SET_BG') {
        // this.scene.onBgChange(state.collage.bg)
      } else if (mutation.type === 'SET_ALL_BGS') {
        // nop
        // this.bgOk = true
        // this.checkIfReady()
      } else if (mutation.type === 'SET_ASSETS') {
        // this.scene.init(this.collage)
        // this.scene.onCollageChange(state.collage.sentence)
        // this.scene.onBgChange(state.collage.bg)

        // nop
        // this.stcOk = true
        // this.checkIfReady()
      }
    })
  },
  beforeDestroy () {
    if (this.unsubscribe) this.unsubscribe()
    window.removeEventListener('resize', this.onResize)
    // destroy scene function
  },
  methods: {
    start () {
      if (this.scene) this.scene.init(this.collage)
    },
    randomId (array) {
      const r = array[Math.floor(Math.random() * (array.length - 1))]
      return r
    },
    createScene () {
      this.scene = new Canvas(this.$refs.wrapper, this.$device, this.collage)
      window.addEventListener('resize', this.onResize)
    },
    onResize () {
      if (this.scene) this.scene.resize()
    },
    async takeScreenshot () {
      this.loading = true

      if (this.tl) this.tl.kill()

      this.tl = gsap.timeline({defaults: {}})

      this.tl.fromTo(this.$refs.svg, {strokeDasharray: 3400, strokeDashoffset: 3400, delay: 0 }, { repeat: 2, ease: 'none', duration: 4, strokeDashoffset: -3400 })

      await gsap.fromTo(this.$refs.svg, {opacity: 0}, { duration: 0.4, opacity: 1, delay: 0 })
      await gsap.fromTo(this.$refs.svg2, {fillOpacity: 0}, { duration: 0.4, fillOpacity: 1, delay: 0 })

      if (this.scene) {
        const blob = await this.scene.takeScreenshot()

        gsap.fromTo(this.$refs.svg, {opacity: 1}, { duration: 0.4, opacity: 0, delay: 1 })
        await gsap.fromTo(this.$refs.svg2, {fillOpacity: 1}, { duration: 0.4, fillOpacity: 0, delay: 1 })
        this.tl.kill()

        this.$store.commit('SET_SCREENSHOT', blob)
        this.loading = false

      }
    }
  }
}
</script>

<style lang="stylus" >
.MainCanvas
  position relative
  z-index 5
  // padding-top 56.25% //16:9
  // width 100%
  height 65vh
  width 100%
  border-radius 5px
  left 0px
  top 0px
  &-wrapper
    position absolute
    width 100%
    height 100%
    left 0px
    top 0px
  // overflow hidden
  img
    position absolute
    opacity 0
  
  &-rect
    position absolute
    width calc(100%)
    height calc(100%)
    top 0
    left 0
    z-index 2
    pointer-events none
    svg
      width 100%
      height 100%
      // stroke-dasharray 800%
      stroke-width 3px
      stroke white
      fill #1b1b1b
      fill-opacity 0
  
  &-rect--loader
    z-index 3
    svg
      width 100%
      height 100%
      stroke-width 3px
      stroke red
      fill none
      opacity 0
    
  // &:after
  //   content ''
  //   position absolute
  //   user-select none
  //   pointer-events none
  //   width 100%
  //   height 100%
  //   top 0
  //   left 0
  //   z-index 11
  //   background rgb(0,0,0)
  //   background linear-gradient(0deg, rgba(0,0,0,0.6) 0%, rgba(255,255,255,0) 20%, rgba(255,255,255,0) 80%, rgba(0,0,0,0.6) 100%)

@media screen and (max-width:600px) and (orientation:portrait)
  .MainCanvas
    padding-top 126%
    height 0
</style>
